import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { doraMetricsDefaultTitle } from '../translation';

const ANNOTATION_PROJECT_SLUG = 'gitflic.ru/project-slug';

export const doraMetricsEntityContentExtension: ExtensionDefinition<any> =
  EntityContentBlueprint.make({
    params: {
      path: 'dora-metrics',
      title: doraMetricsDefaultTitle,
      filter: entity =>
        entity.spec?.type === 'service' ||
        Boolean(entity.metadata.annotations?.[ANNOTATION_PROJECT_SLUG]),
      loader: () =>
        import('../components/DoraMetricsContent').then(m => (
          <m.DoraMetricsContent />
        )),
    },
  }) as ExtensionDefinition<any>;
